import { Form, FormRenderProps } from 'react-final-form';
import LoadingButton from '@mui/lab/LoadingButton';
import { Stack, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

import { makeZodValidate as makeValidate, TextField, Button } from '@occc-app/design-system';

import { schema } from './segment-update-details-form.schema';

import { SegmentFormValues } from '../../segments.types';

type SegmentUpdateDetailsModalProps = {
  onClose: () => void;
  isUpdateInProgress: boolean;
  onSubmit: (values: SegmentFormValues) => Promise<void>;
  initialFormValues: Partial<SegmentFormValues>;
};

const validate = makeValidate(schema);

export const SegmentUpdateDetailsModal = ({
  onClose,
  isUpdateInProgress,
  onSubmit,
  initialFormValues,
}: SegmentUpdateDetailsModalProps) => {
  const renderForm = ({ handleSubmit, pristine }: FormRenderProps<SegmentFormValues>) => {
    return (
      <form onSubmit={handleSubmit}>
        <DialogTitle>Edit Segment Details</DialogTitle>
        <DialogContent>
          <Stack spacing={3} mt={2}>
            <TextField
              name={'name' satisfies keyof SegmentFormValues}
              label='Name'
              margin='none'
              disabled={isUpdateInProgress}
            />

            <TextField
              name={'description' satisfies keyof SegmentFormValues}
              label='Description'
              margin='none'
              disabled={isUpdateInProgress}
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button variant='text' size='medium' onClick={onClose}>
            Cancel
          </Button>
          <LoadingButton
            variant='contained'
            type='submit'
            loading={isUpdateInProgress}
            disabled={isUpdateInProgress || pristine}
          >
            Save
          </LoadingButton>
        </DialogActions>
      </form>
    );
  };

  return (
    <Dialog open onClose={onClose} maxWidth='xs' fullWidth>
      <Form<SegmentFormValues>
        onSubmit={onSubmit}
        render={renderForm}
        validate={validate}
        initialValues={initialFormValues}
        keepDirtyOnReinitialize
      />
    </Dialog>
  );
};
